import { Overlay } from './types';

export const overlay_default: Overlay = {
  drawer: { is_open: false },
  candle_validations: { is_open: false },
  candle_workers: { is_open: false },
  strategies: { is_open: false },
  strategy: { is_open: false },
  signals: { is_open: false },
  triggers: { is_open: false },
};
